import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { TemplateReportService } from 'src/app/shared/services/template-report.service';
import { ReportlinksserviceService } from '../../../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../../../user-routing/user-routing.module';
import {constants} from '../../../../shared/common/contants';
import { ActivatedRoute, Router } from '@angular/router';
import { JsignalService } from 'src/app/shared/services/jsignal.service';

@Component({
    selector: 'app-product-library',
    templateUrl: './product-library.component.html',
    styleUrls: ['./product-library.component.scss'],
    standalone: false
})
export class ProductLibraryComponent implements OnInit {
  backgroundColorScreen: string;
  buttonColor: string;
    rowbindingdata;

  //selectedTable;
  responserequest;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  gridApi;

  gridColumnApi

  columnDefs

  defaultColDef

  components

  options: any;

  gridOptions = {
    animateRows: true,
    enableSorting: true,
    enableCellChangeFlash: true,
    context: { componentParent: this },
  };
  value;
  rowData: any[] = [];

 queryData:any;
  constructor(private userRoutingModule:UserRoutingModule,
    private retrieveScreenAccess:RetrieveScreenAccess,
    private msg: ErrorMessages,
     private validation: validationmethod,
      private commoService: CommonService, 
      private spinner: NgxUiLoaderService, 
      private snackBar: MatSnackBar, 
      private dialog: MatDialog, 
      private fb: FormBuilder,
      private localStorage: LocalStorageSettingsService,
    private constants: constants,
    private jsignalsService: JsignalService,
    private service: ReportingServiceService,
    private validate: validationmethod,
      private router: Router,
      private route: ActivatedRoute) { }

  ngOnInit(): void {
     this.queryData=history.state?.selectedRowData
    this.intializeGrid();
    this.loadGridData(); 
  }

  intializeGrid() {
      
  this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
  this.buttonColor = this.localStorage.getSettings("ColorA");
  this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };

    this.columnDefs=[
     
{
  headerName: 'Product Id',
  headerTooltip: 'Product Id',
  tooltipValueGetter: (params) => 'Product Id : ' + params.value,
  field: 'id',
  filter: 'agSetColumnFilter',
  width: 180,
  cellRenderer: (params) => {
    return `<span class="id-link" style="color:#1976d2;cursor:pointer;text-decoration:underline;">
              ${params.value}
            </span>`;
  },
  onCellClicked: (params) => {
    if (params.value) {
      params.context.componentParent.openProductDetails(params.value);
    }
  }
},

      {
        headerName: 'Product Name ',
        headerTooltip: 'Product Name ',
        tooltipValueGetter: (params) =>
          'Product Name  : ' + this.jsignalsService.formatValues(params.value),
        field: 'name__v',
        valueFormatter : (params) => this.jsignalsService.formatValues(params.value),
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Product Type ',
        headerTooltip: 'Product Type ',
        tooltipValueGetter: (params) =>
          'Product Type : ' + this.jsignalsService.formatValues(params.value),
        field: 'object_type__v_name__v',
         valueFormatter : (params) => this.jsignalsService.formatValues(params.value),
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Organization',
        headerTooltip: 'Organization',
        tooltipValueGetter: (params) =>
          'Organization : ' + this.jsignalsService.formatValues(params.value),
        field: 'organization__v_name__v',
         valueFormatter : (params) => this.jsignalsService.formatValues(params.value),
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Country',
        headerTooltip: 'Country',
        tooltipValueGetter: (params) =>
          'Country : ' + this.jsignalsService.formatValues(params.value),
        field: 'country_names',
         valueFormatter: (params) => {
          if (!params.value) return '';

          try {
            const arr = JSON.parse(params.value);
            return arr.filter(v => v && v.trim() !== '').join(', ');
          } catch (e) {
            console.error('Error parsing country names:', e);
            return params.value;
          }
        },
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'International Birth Date',
        headerTooltip: 'International Birth Date',
        tooltipValueGetter: (params) =>
          'International Birth Date : ' + this.jsignalsService.formatValues(params.value),
        field: 'international_birthdate__v',
         valueFormatter : (params) => this.jsignalsService.formatValues(params.value),
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'LifeCycle State',
        headerTooltip: 'LifeCycle State',
        tooltipValueGetter: (params) =>
          'LifeCycle State : ' + this.jsignalsService.formatValues(params.value),
        field: 'lifecycle__v',
         valueFormatter : (params) => this.jsignalsService.formatValues(params.value),
        filter: 'agTextColumnFilter',
        width: 180,
      },
      // {
      //   headerName: 'Reported Indication',
      //   headerTooltip: 'Reported Indication',
      //   tooltipValueGetter: (params) =>
      //     'Reported Indication : ' + this.jsignalsService.formatValues(params.value),
      //   field: 'reportedIndications',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      // {
      //   headerName: 'Created By',
      //   headerTooltip: 'Created By',
      //   tooltipValueGetter: (params) =>
      //     'Created By : ' + params.value,
      //   field: 'createdBy',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      // {
      //   headerName: 'Created Date',
      //   headerTooltip: 'Created Date',
      //   tooltipValueGetter: (params) =>
      //     'Created Date : ' + params.value,
      //   field: 'createdDate',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      
      // {
      //   headerName: 'Last Modified By',
      //   headerTooltip: 'Last Modified By',
      //   tooltipValueGetter: (params) =>
      //     'Last Modified By : ' + params.value,
      //   field: 'lastModifiedBy',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },
      // {
      //   headerName: 'Last Modified Date',
      //   headerTooltip: 'Last Modified Date',
      //   tooltipValueGetter: (params) =>
      //     'Last Modified Date: ' + params.value,
      //   field: 'lastModifiedDate',
      //   filter: 'agTextColumnFilter',
      //   width: 180,
      // },

    ]
    this.paginationPageSize = 10;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    }

   //excel export function
  onBtExport() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();
      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.rowbindingdata.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.rowbindingdata.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.rowbindingdata.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.rowbindingdata.api.paginationGoToLastPage();
  }
  //pagination code ends

  onGridReady(params){
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
   
  }

//   generateUniqueDummyData() {
//   const organizations = [
//     'Veeva', 'Vault', 'JLW', 'IPM', 'PVWorks', 'TrackWise', 'Argus', 'ArisGlobal'
//   ];

//   const productTypes = [
//     'Biologic', 'Vaccine', 'Antibiotic', 'Analgesic', 'Drug',
//     'Steroid', 'Antiviral',
//     'Antifungal', 'Immunotherapy', 'Diagnostic Agent'
//   ];

//   const productStates = [
//     'Active', 'Inactive'
//   ];

//   const country = [
//     'USA', 'India', 'Germany', 'France', 'Japan', 'Canada', 'Australia', 'Brazil'
//   ];

//   const reportedIndications = [
//     'Indication A', 'Indication B', 'Indication C', 'Indication D',
//     'Indication E', 'Indication F', 'Indication G', 'Indication H'
//   ];

//   const data: any[] = [];

//   for (let i = 1; i <= 50; i++) {
//     data.push({
//       id: `V1000000000K${2000 + i}`,
//       productName: `Product ${i}`,
//       Organization: organizations[Math.floor(Math.random() * organizations.length)], // ⭐ random org
//       ibd: this.randomDate(new Date(1995, 0, 1), new Date(2023, 11, 31)),           // ⭐ random date
//       productState: productStates[i % productStates.length],
//       createdBy: `USER-${4000 + i}`,
//       createdDate: new Date(2020, 0, i).toISOString(),
//       lastModifiedBy: `USER-${5000 + i}`,
//       lastModifiedDate: new Date(2024, 5, i).toISOString(),
//       productTypes: productTypes[i % productTypes.length],
//       country: country[Math.floor(Math.random() * country.length)],
//       reportedIndications: reportedIndications[i % reportedIndications.length],
//     });
//   }

//   return data;
// }
// randomDate(start: Date, end: Date) {
//   const date = new Date(
//     start.getTime() + Math.random() * (end.getTime() - start.getTime())
//   );
//   return date.toISOString().split("T")[0]; // YYYY-MM-DD
// }


openProductDetails(productId: string) {
  console.log("Clicked Product:", productId);

    // Example: open a dialog
  // this.dialog.open(ProductDetailsComponent, { data: { productId } });

  // Example: navigate to product detail page
   
  this.router.navigate(['details',productId], { relativeTo: this.route });


}
  goBack() {
    this.queryData=undefined
    this.router.navigate(['../'], { relativeTo: this.route.parent });
  }

  loadGridData() {
     this.spinner.start();
    this.jsignalsService.getLibraryProducts().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.rowData = response;
        console.log(this.rowData);
        
          if(this.queryData){
            
              let stateData=this.queryData
              console.log(stateData);
              
            let searchedRowData=this.rowData.filter(item=>item.id==stateData.id)[0];
            if(searchedRowData.id){
               this.openProductDetails(stateData.id)
            }
           
          }
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching library products:", error);
        this.snackBar.open("Failed to load library products", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }


}
